module.exports = __webpack_public_path__ + "img/xinshou.b87f0d06.png";